// extracted by mini-css-extract-plugin
export default {"container":"page_container__Y3k2B"};